import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, onBeforeUnmount } from "vue";
import BaseButton from "../BaseButton.vue";
import SvgClose from "@/assets/icons/close.svg";
import SvgReset from '@/assets/icons/reload.svg';
import SvgCreate from '@/assets/icons/magic-wand-light.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDialog',
  props: {
    value: { type: Boolean },
    title: null,
    maxWidth: { default: '600px' },
    cancelText: { default: 'Отменить' },
    approveText: { default: 'Создать' },
    hideFooter: { type: Boolean },
    hideFooterActions: { type: Boolean },
    hideCancelButton: { type: Boolean },
    disabledApproveButton: { type: Boolean },
    hideApproveButton: { type: Boolean },
    hideCloseButton: { type: Boolean }
  },
  emits: [
    'update:value',
    'close',
    'cancel',
    'approve',
    'click-outside',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { value: boolean, title?: string, maxWidth: string, cancelText: string, approveText: string, hideFooter?: boolean, hideFooterActions?: boolean, hideCancelButton?: boolean, disabledApproveButton?: boolean, hideApproveButton?: boolean, hideCloseButton?: boolean }

// @ts-ignore



const baseDialogRef = ref<HTMLElement | null>(null);

const handleOutsideDialogClick = (event: MouseEvent): void => {
    if (baseDialogRef.value?.contains(event.target as Node)) {
        emits('update:value', false);
        emits('click-outside', false);
    }
};

const handleCloseDialog = (): void => {
    emits('update:value', false);
    emits('close', false);
};

const handleCancelDialog = (): void => {
    emits('update:value', false);
    emits('cancel', false);
};

const handleApproveDialog = (): void => {
    emits('update:value', false);
    emits('approve');
};

const setDialogInBody = (): void => {
    document.body.appendChild(baseDialogRef.value);
};

onMounted(() => setDialogInBody());

onBeforeUnmount(() => document.body.removeChild(baseDialogRef.value));

return { __sfc: true,props, emits, baseDialogRef, handleOutsideDialogClick, handleCloseDialog, handleCancelDialog, handleApproveDialog, setDialogInBody, BaseButton, SvgClose, SvgReset, SvgCreate }
}

})